import React, { Component } from 'react';
import { Icon } from 'antd';
import TableC from '../../basicElement/TableC';
import Filter from './Filter';
import ExportModal from './ExportModal';
import DetailModal from './DetailModal';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import UserSider from '../UserSider';
import jquery from 'jquery';
import '../css/style.less';

class AreaCityAnalysis extends Component {
    state = {
        data: [],
        config: [],
        loading: false,
        searchParams: {},
        spreadStatus: false
    }

    loadData = () => {
        const { searchParams, areaChooseAry } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryAnalysisRegionCityList,
            data: {
                limit: 9,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                datas.forEach((item, index) => {
                    item.spreadStatus = false;
                });
                this.setState({
                    data: datas,
                    loading: false,
                }, () => {
                    datas.forEach((item, index) => {
                        if ((areaChooseAry || []).indexOf(item.areaId) > -1) {
                            this.spreadArea(item);
                        }
                    });
                });
            }
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        this.setState({
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    export = (params = {}) => {
        const {areaName} = this.state.searchParams;
        this.setState({
            searchParams: { ...params,areaName },
        }, () => {
            this.exportModal.show();
        });   
    }

    getTextRender = (type) => {
        return (text, record) => {
            const { yearMonth, cityId } = record;
            if (yearMonth == '区域合计' || yearMonth == '总计(公司层面)' || (!cityId)) {
                text = <div style={{ fontWeight: 'bold' }}>{text}</div>;
            } else if (type) {
                text = <a onClick={() => this.showDetailModal(type, record)}>{text}</a>;
            }
            return text;
        }
    }

    spreadArea = (row) => {
        const { searchParams } = this.state;
        const { areaId, spreadStatus } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryAnalysisRegionCityDetailList,
            data: {
                ...searchParams,
                areaId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                const { data = [] } = this.state;

                const idx = data.findIndex(i => (i.areaId == areaId) && (!i.analysisRegionCityId));
                if (spreadStatus == false) {//展开
                    data.splice(idx + 1, 0, ...datas);
                } else {//收起
                    data.splice(idx + 1, datas.length);
                }
                data[idx]['spreadStatus'] = !spreadStatus;
                // const target = jquery('.ant-table-scroll .ant-table-body')[0];
                // console.log(target);
                // if (target) {
                //     jquery(target).scrollTop(0)
                //         .scrollLeft(0);
                // }
                this.setState({
                    data,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        }
        $.sendRequest(options);
    }

    spreadChange = (data) => {
        this.setState({ data });
    }

    getColumns = () => {
        const columns = [{
            title: '时间',
            dataIndex: 'yearMonth',
            key: 'yearMonth',
            fixed: 'left',
            width: 80,
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {},
                };
                const { yearMonth } = row;
                if (yearMonth === '区域合计' || yearMonth === '总计(公司层面)') {
                    obj.children = <div style={{ fontWeight: 'bold' }}>{value}</div>;
                    obj.props.colSpan = 3;
                }
                return obj;
            },
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            fixed: 'left',
            width: 80,
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {},
                };
                const { yearMonth, spreadStatus, analysisRegionCityId } = row;
                if (yearMonth == '区域合计' || yearMonth == '总计(公司层面)') {
                    obj.props.colSpan = 0;
                } else {
                    if (!analysisRegionCityId) {
                        obj.props.colSpan = 2;
                        obj.children = (
                            <div style={{ width: 163, fontWeight: 'bold' }}>
                                {value}
                                <Icon
                                    type={spreadStatus ? "minus-square-o" : "plus-square-o"}
                                    style={{ float: 'right', marginRight: 4, fontSize: '16px', color: '#a7a7a7', cursor: "pointer" }}
                                    onClick={() => this.spreadArea(row)}
                                />
                            </div>
                        );
                    }
                }
                return obj;
            },
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            fixed: 'left',
            width: 100,
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {},
                };
                const { yearMonth, analysisRegionCityId } = row;
                if (yearMonth == '区域合计' || yearMonth == '总计(公司层面)') {
                    obj.props.colSpan = 0;
                } else {
                    if (!analysisRegionCityId) {
                        obj.props.colSpan = 0;
                    }
                }
                return obj;
            },
        }, {
            title: 'CRC人数',
            dataIndex: 'crcNum',
            key: 'crcNum',
            width: 80,
            render: this.getTextRender('crcNum'),
        }, {
            title: '主管以上人数',
            dataIndex: 'aboveSupervisorNum',
            key: 'aboveSupervisorNum',
            width: 100,
            render: this.getTextRender('aboveSupervisorNum'),
        }, {
            title: 'CRC新增',
            dataIndex: 'crcAddNum',
            key: 'crcAddNum',
            width: 80,
            render: this.getTextRender('crcAddNum'),
        }, {
            title: '净增CRC人数',
            dataIndex: 'netAddCrcNum',
            key: 'netAddCrcNum',
            width: 80,
            render: this.getTextRender(),
        }, {
            title: '新人人数',
            dataIndex: 'newEmployeeNum',
            key: 'newEmployeeNum',
            width: 80,
            render: this.getTextRender('newEmployeeNum'),
        }, {
            title: '当月新site上岗确认FTE',
            dataIndex: 'newOnDutyConfirmFte',
            key: 'newOnDutyConfirmFte',
            width: 100,
            render: this.getTextRender('newOnDutyConfirmFte'),
        }, {
            title: '项目确认FTE',
            dataIndex: 'investigationConfirmFte',
            key: 'investigationConfirmFte',
            width: 100,
            render: this.getTextRender('investigationConfirmFte'),
        }, {
            title: '新人确认FTE',
            dataIndex: 'newEmployeeConfirmFte',
            key: 'newEmployeeConfirmFte',
            width: 100,
            render: this.getTextRender('newEmployeeConfirmFte'),
        }, {
            title: '非新人产出率',
            dataIndex: 'notNewEmpOutputRateShow',
            key: 'notNewEmpOutputRateShow',
            width: 100,
            render: this.getTextRender(),
        }, {
            title: '临床协调员职位的产出率',
            dataIndex: 'crcPositionOutputRateShow',
            key: 'crcPositionOutputRateShow',
            width: 100,
            render: this.getTextRender(),
        }, {
            title: '新人产出率',
            dataIndex: 'newEmployeeOutputRateShow',
            key: 'newEmployeeOutputRateShow',
            width: 80,
            render: this.getTextRender(),
        }, {
            title: '医院覆盖量',
            children: [{
                title: '所有累计项目',
                dataIndex: 'allInvHospitalNum',
                key: 'allInvHospitalNum',
                width: 80,
                render: this.getTextRender('allInvHospitalNum'),
            }, {
                title: '进行中项目',
                dataIndex: 'underwayInvHospitalNum',
                key: 'underwayInvHospitalNum',
                width: 80,
                render: this.getTextRender('underwayInvHospitalNum'),
            }]
        }, {
            title: '科室覆盖量',
            children: [{
                title: '所有累计项目',
                dataIndex: 'allInvDeptNum',
                key: 'allInvDeptNum',
                width: 80,
                render: this.getTextRender('allInvDeptNum'),
            }, {
                title: '进行中项目',
                dataIndex: 'underwayInvDeptNum',
                key: 'underwayInvDeptNum',
                width: 80,
                render: this.getTextRender('underwayInvDeptNum'),
            }]
        }, {
            title: '承担项目数量',
            children: [{
                title: '所有累计项目',
                dataIndex: 'undertakeAllInvNum',
                key: 'undertakeAllInvNum',
                width: 80,
                render: this.getTextRender('undertakeAllInvNum'),
            }, {
                title: '进行中项目',
                dataIndex: 'undertakeUnderwayInvNum',
                key: 'undertakeUnderwayInvNum',
                width: 80,
                render: this.getTextRender('undertakeUnderwayInvNum'),
            }]
        }, {
            title: '临床I期项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'clinicalOneAllInvNum',
                key: 'clinicalOneAllInvNum',
                width: 80,
                render: this.getTextRender('clinicalIAll'),
            }, {
                title: '进行中项目',
                dataIndex: 'clinicalOneUnderwayInvNum',
                key: 'clinicalOneUnderwayInvNum',
                width: 80,
                render: this.getTextRender('clinicalIProcess'),
            }]
        }, {
            title: '临床II期项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'clinicalTwoAllInvNum',
                key: 'clinicalTwoAllInvNum',
                width: 80,
                render: this.getTextRender('clinicalIIAll'),
            }, {
                title: '进行中项目',
                dataIndex: 'clinicalTwoUnderwayInvNum',
                key: 'clinicalTwoUnderwayInvNum',
                width: 80,
                render: this.getTextRender('clinicalIIProcess'),
            }]
        }, {
            title: '临床III期项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'clinicalThreeAllInvNum',
                key: 'clinicalThreeAllInvNum',
                width: 80,
                render: this.getTextRender('clinicalIIIAll'),
            }, {
                title: '进行中项目',
                dataIndex: 'clinicalThreeUnderwayInvNum',
                key: 'clinicalThreeUnderwayInvNum',
                width: 80,
                render: this.getTextRender('clinicalIIIProcess'),
            }]
        }, {
            title: '临床IV期项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'clinicalFourAllInvNum',
                key: 'clinicalFourAllInvNum',
                width: 80,
                render: this.getTextRender('clinicalIVAll'),
            }, {
                title: '进行中项目',
                dataIndex: 'clinicalFourUnderwayInvNum',
                key: 'clinicalFourUnderwayInvNum',
                width: 80,
                render: this.getTextRender('clinicalIVProcess'),
            }]
        }, {
            title: '其他项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'otherAllInvNum',
                key: 'otherAllInvNum',
                width: 80,
                render: this.getTextRender('otherInvAll'),
            }, {
                title: '进行中项目',
                dataIndex: 'otherUnderwayInvNum',
                key: 'otherUnderwayInvNum',
                width: 80,
                render: this.getTextRender('otherInvProcess'),
            }]
        }, {
            title: '肿瘤项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'tumourAllInvNum',
                key: 'tumourAllInvNum',
                width: 80,
                render: this.getTextRender('tumourAllInvNum'),
            }, {
                title: '进行中项目',
                dataIndex: 'tumourUnderwayInvNum',
                key: 'tumourUnderwayInvNum',
                width: 80,
                render: this.getTextRender('tumourUnderwayInvNum'),
            }]
        }, {
            title: '非肿瘤项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'notTumourAllInvNum',
                key: 'notTumourAllInvNum',
                width: 80,
                render: this.getTextRender('notTumourAllInvNum'),
            }, {
                title: '进行中项目',
                dataIndex: 'notTumourUnderwayInvNum',
                key: 'notTumourUnderwayInvNum',
                width: 80,
                render: this.getTextRender('notTumourUnderwayInvNum'),
            }]
        }, {
            title: '综合项目数',
            children: [{
                title: '所有累计项目',
                dataIndex: 'comprehensiveAllNum',
                key: 'comprehensiveAllNum',
                width: 80,
                render: this.getTextRender('comprehensiveAllNum'),
            }, {
                title: '进行中项目',
                dataIndex: 'comprehensiveUnderwayNum',
                key: 'comprehensiveUnderwayNum',
                width: 80,
                render: this.getTextRender('comprehensiveUnderwayNum'),
            }]
        }, {
            title: '处于入组期项目数量',
            children: [{
                title: '单中心项目',
                dataIndex: 'intoGroupItemInvestigationNum',
                key: 'intoGroupItemInvestigationNum',
                width: 80,
                render: this.getTextRender('intoGroupItemInvestigationNum'),
            }, {
                title: '多中心项目',
                dataIndex: 'intoGroupMultiSiteInvNum',
                key: 'intoGroupMultiSiteInvNum',
                width: 80,
                render: this.getTextRender('intoGroupMultiSiteInvNum'),
            }]
            // dataIndex: 'intoGroupItemInvestigationNum',
            // key: 'intoGroupItemInvestigationNum',
            // width: 80,
            // render: this.getTextRender('intoGroupItemInvestigationNum'),
        }, {
            title: '当月入组病例数',
            children: [{
                title: '肿瘤项目',
                dataIndex: 'currentMonthTumourPatientNum',
                key: 'currentMonthTumourPatientNum',
                width: 80,
                render: this.getTextRender('currentMonthTumourPatientNum'),
            }, {
                title: '非肿瘤项目',
                dataIndex: 'currentMonthNotTumourPatientNum',
                key: 'currentMonthNotTumourPatientNum',
                width: 80,
                render: this.getTextRender('currentMonthNotTumourPatientNum'),
            }, {
                title: '综合项目',
                dataIndex: 'currentMonthComprehensivePatientNum',
                key: 'currentMonthComprehensivePatientNum',
                width: 80,
                render: this.getTextRender('currentMonthComprehensivePatientNum'),
            }]
        }, {
            title: '当月新增访视数',
            children: [{
                title: '肿瘤项目',
                dataIndex: 'currentMonthTumourAddVisitNum',
                key: 'currentMonthTumourAddVisitNum',
                width: 80,
                render: this.getTextRender('currentMonthTumourAddVisitNum'),
            }, {
                title: '非肿瘤项目',
                dataIndex: 'currentMonthNotTumourAddVisitNum',
                key: 'currentMonthNotTumourAddVisitNum',
                width: 80,
                render: this.getTextRender('currentMonthNotTumourAddVisitNum'),
            }, {
                title: '综合项目',
                dataIndex: 'curMonthCompAddVisitNum',
                key: 'curMonthCompAddVisitNum',
                width: 80,
                render: this.getTextRender('curMonthCompAddVisitNum'),
            }]
        }, {
            title: '当月新增确认标准访视数',
            children: [{
                title: '肿瘤项目',
                dataIndex: 'currentMonthTumourStandardVisitCount',
                key: 'currentMonthTumourStandardVisitCount',
                width: 80,
                render: this.getTextRender('currentMonthTumourStandardVisitCount'),
            }, {
                title: '非肿瘤项目',
                dataIndex: 'currentMonthNotTumourStandardVisitCount',
                key: 'currentMonthNotTumourStandardVisitCount',
                width: 80,
                render: this.getTextRender('currentMonthNotTumourStandardVisitCount'),
            }, {
                title: '综合项目',
                dataIndex: 'curMonthCompStandVisitCount',
                key: 'curMonthCompStandVisitCount',
                width: 80,
                render: this.getTextRender('curMonthCompStandVisitCount'),
            }]
        }, {
            title: '新启动中心数量',
            dataIndex: 'newStartSiteNum',
            key: 'newStartSiteNum',
            width: 80,
            render: this.getTextRender('newStartSiteNum'),
        }, {
            title: '新启动中心-启动实际花费时长',
            dataIndex: 'newStartSiteActualTime',
            key: 'newStartSiteActualTime',
            width: 120,
            render: this.getTextRender(),
        }, {
            title: '新启动中心-平均启动时长',
            dataIndex: 'newStartSiteAvgTime',
            key: 'newStartSiteAvgTime',
            width: 100,
            render: this.getTextRender(),
        }, {
            title: '新启动中心-最大启动时长',
            dataIndex: 'newStartSiteMaxTime',
            key: 'newStartSiteMaxTime',
            width: 100,
            render: this.getTextRender(),
        }, {
            title: '新启动中心-最小启动时长',
            dataIndex: 'newStartSiteMinTime',
            key: 'newStartSiteMinTime',
            width: 100,
            render: this.getTextRender(),
        }, {
            title: '在组患者数量',
            dataIndex: 'inGroupPatientNum',
            key: 'inGroupPatientNum',
            width: 100,
            render: this.getTextRender('inGroupPatientNum'),
        }, {
            title: '重大事件发生数量',
            dataIndex: 'majorEventsNum',
            key: 'majorEventsNum',
            width: 80,
            render: this.getTextRender('majorEventsNum'),
        }];
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map((item, index) => {
            const { areaId, analysisRegionCityId } = item;
            return {
                key: `${areaId || -1}` + `${analysisRegionCityId || ''}`,
                ...item,
            };
        });
        return dataSource;
    }

    showDetailModal = (type, record) => {
        this.detailModalRef.show(type, record);
    }

    setChooseArea = (areaChooseAry) => {
        this.setState({ areaChooseAry });
    }

    render() {
        const { loading, searchParams } = this.state;
        const scrollY = (document.body || document.documentElement).clientHeight - 150;
        return (
            <div className="content">
                <UserSider selectKey='areaCityAnalysis' openKeys={['sub2']}/>
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                        setChooseArea={this.setChooseArea}
                    />
                    <TableC
                        scrollY={scrollY}
                        loading={loading}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        className="areaCityAnalysis"
                        rowKey='key'
                    />
                    <ExportModal ref={el => this.exportModal = el} searchParams={searchParams} />
                    <DetailModal ref={el => this.detailModalRef = el} cur={'leader'} />
                </div>
            </div>
        );
    }
}

export default AreaCityAnalysis;


// WEBPACK FOOTER //
// ./src/components/user/areaCityAnalysis/index.js